import {Component, HostListener, OnInit, QueryList, ViewChildren} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BatchSelectFieldsComponent } from 'src/app/dialogs/season-manager-dialogs/batch-select-fields/batch-select-fields.component';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { SeasonManagerService } from 'src/app/services/season-manager.service';
import { SeasonSharedDataService } from 'src/app/services/season-shared-data.service';
import { SeasonFieldInputComponent } from '../season-field-input/season-field-input.component';
import { BatchUpdateComponent } from 'src/app/dialogs/season-manager-dialogs/batch-update/batch-update.component';
import { BulkCostManagerComponent } from 'src/app/dialogs/season-manager-dialogs/bulk-cost-manager/bulk-cost-manager.component';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import {SeasonFieldBase} from "../../dto/season-dto/season-field-base";

@Component({
    selector: 'app-season-batch-update',
    templateUrl: './season-batch-update.component.html',
    styleUrls: ['./season-batch-update.component.css'],
    standalone: false
})
export class SeasonBatchUpdateComponent implements OnInit {

  @ViewChildren(SeasonFieldInputComponent) seasoinFieldInput: QueryList<SeasonFieldInputComponent>;

  seasonFormData: SeasonFieldBase = null;
  selectedFields: any[] = [];

  seasonId: number = 0;
  fieldId: number = 0;
  tenantId: number = 0;
  containerHeight: string = '';

  fieldName: string = '-';

  isInAnotherActiveSeason: boolean = false;

  constructor(
    public dialog: MatDialog,
    public selectFieldsDialog: MatDialog,
    private seasonManagerService: SeasonManagerService,
    private seasonSharedDataService: SeasonSharedDataService,
    private route: ActivatedRoute,
    public nav: NavBarComponent,
    private snackBar: MatSnackBar,
  ) {
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.containerHeight = window.innerHeight - 450 + 'px';
  }

  ngOnInit(): void {
    this.onResize();
    this.setSeasonId();

    this.route.url.subscribe((segments: UrlSegment[]) => {
      const url = segments.map(segment => segment.path).join('/');

      if (url.includes('sample-batch-update')) {
        this.isInAnotherActiveSeason = true;
        this.seasonSharedDataService.updateIsDisabledData(this.isInAnotherActiveSeason);
      }
    })
    this.seasonSharedDataService.setIsSaveBtnVisibleDataSubjectData(false);
    this.seasonSharedDataService.updateIsHiddenData(false);
  }

  onFormDataChange(data: any) {
    this.seasonFormData = data.value;
  }

  openSelectFieldsDialog() {

    const dialogRef = this.selectFieldsDialog.open(BatchSelectFieldsComponent, {

      data: {
        seasonId: this.seasonId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedFields = result.selectedFields;
      }
    });
  }

  removeField(id: number) {
    this.selectedFields = this.selectedFields.filter(field => field.id !== id);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
    });
  }

  openUpdateDialog() {

    const dialogRef = this.selectFieldsDialog.open(BatchUpdateComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result.option == 'save') {
        this.updateSeasonDetails();
      }
    });
  }

  updateSeasonDetails() {

    if (this.selectedFields.length !== 0) {
      let count = 0;
      this.selectedFields.forEach((seasonForm) => {
        if (seasonForm) {
          this.nav.toggleLoading(true);
          // PUT UPDATE BASE DETAILS
          const seasonDetails = {...this.seasonFormData};
          delete seasonDetails.fieldId;
          delete seasonDetails.id;
          delete seasonDetails.grainFeed;
          delete seasonDetails.vegetables;
          delete seasonDetails.vineyard;
          delete seasonDetails.fruit;

          this.seasonManagerService.updateSeasonFieldBaseDetails(seasonForm.id, seasonDetails).subscribe({
            next: (response) => {
              // console.log('Update successful:', response);
            },
            error: () => {
              // console.error('Error updating data:', error);
            },
            complete: () => {
              count++;
              if(!seasonForm.fieldTypeId) {
                if(this.selectedFields.length === count) {
                  this.clearData();
                }
              }
            }
          });
        }

        if (this.seasonFormData?.fieldTypeId) {

          //POST NEW DATA BASED ON FIELD TYPE

          if (this.seasonFormData?.fieldTypeId == 1) {
            this.seasonManagerService.postSeasonDetailsGrainFeed(seasonForm.id, this.seasonFormData.grainFeed).subscribe({
              next: (response) => {
                // console.log('Update successful:', response);
              },
              error: () => {
                // console.error('Error updating data:', error);
              },
              complete: () => {
                count++;
                if(this.selectedFields.length === count) {
                  this.clearData();
                }
              }
            });
          }

          if (this.seasonFormData?.fieldTypeId == 2) {
            this.seasonManagerService.postSeasonDetailsVegetables(seasonForm.id, this.seasonFormData.vegetables).subscribe({
              next: (response) => {
                // console.log('Update successful:', response);
              },
              error: () => {
                this.nav.toggleLoading(false);
                // console.error('Error updating data:', error);
              },
              complete: () => {
                count++;
                if(this.selectedFields.length === count) {
                  this.clearData();
                }
              }
            });
          }

          if (this.seasonFormData?.fieldTypeId == 3) {
            this.seasonManagerService.postSeasonDetailsVineyard(seasonForm?.id, this.seasonFormData.vineyard).subscribe({
              next: (response) => {
                // console.log('Update successful:', response);
              },
              error: () => {
                this.nav.toggleLoading(false);
                // console.error('Error updating data:', error);
              },
              complete: () => {
                count++;
                if(this.selectedFields.length === count) {
                  this.clearData();
                }
              }
            });
          }

          if (this.seasonFormData?.fieldTypeId == 4) {
            this.seasonManagerService.postSeasonDetailsFruit(seasonForm?.id, this.seasonFormData.fruit).subscribe({
              next: (response) => {
                // console.log('Update successful:', response);
              },
              error: () => {
                this.nav.toggleLoading(false);
                // console.error('Error updating data:', error);
              },
              complete: () => {
                count++;
                if(this.selectedFields.length === count) {
                  this.clearData();
                }
              }
            });
          }
        }
      })

    } else {
      this.openSnackBar('Please select fields to batch update', 'DISMISS');
    }
  }

  clearData() {
    this.nav.toggleLoading(false);
    this.selectedFields = [];
    this.seasonFormData = null;
  }

  setSeasonId() {
    this.seasonSharedDataService.seasonIdData$.subscribe(data => {
      this.seasonId = data;
    });
  }

  openBulkCostManager(): void {
    if (this.selectedFields.length === 0) {
      this.snackBar.open('Please select fields first.', 'Dismiss', { duration: 3000 });
      return;
    }

    const dialogRef = this.dialog.open(BulkCostManagerComponent, {
      data: { selectedFields: this.selectedFields },
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.applied) {
        this.snackBar.open('Bulk cost update applied.', 'Dismiss', { duration: 5000 });
      }
    });
  }
}
